import { useField } from 'formik';
import { SelectField } from 'framework/components/select/SelectField';
import { IFormProps } from 'framework/forms/common/IFormProps';
import { nameOf } from 'framework/utils/nameOf';
import { IStandardDocumentDto, LanguageOption, LanguageOptions } from 'gen/ApiClient';
import { useCurrentLanguage } from 'localization/useCurrentLanguage';
import { useLocalization } from 'localization/useLocalization';
import React, { useContext, useEffect, useState } from 'react';
import { RecordContext } from 'shared/records/RecordContext';

interface IProps<TModel> extends IFormProps<TModel> {
	documents: IStandardDocumentDto[];
}

export const FormSelectStandardDocumentField = <TModel extends unknown>({ name, label, documents, ...rest }: IProps<TModel>) => {
	const strings = useLocalization();
	// eslint-disable-next-line
	const [_, __, helpers] = useField<string>(nameOf(name));
	const userLanguage = useCurrentLanguage();
	const [language, setLanguage] = useState<LanguageOption>(userLanguage);
	const { localizedLanguageRecord } = useContext(RecordContext);

	useEffect(() => {
		helpers.setValue(documents.find(t => t.language === language)!.id!);
		// eslint-disable-next-line
	}, [language, documents]);

	return (
		<SelectField<LanguageOption>
			label={strings.language}
			options={LanguageOptions}
			value={language}
			onChange={setLanguage}
			renderValue={t => localizedLanguageRecord[t]}
			getKey={t => t}
		/>
	);
};
